/**
 * Peso Chileno (CLP).
 *
 * Moneda oficial de Chile. NO tiene subdivisiones decimales en la práctica
 * (aunque la ISO 4217 marca 0 decimales). Los montos se expresan siempre
 * como enteros (Math.round para bordes).
 */

export type CLP = {
  /** Monto en pesos chilenos, siempre entero. */
  readonly amount: number;
};

/** Crea un monto CLP desde un número. Redondea al peso más cercano. */
export function clp(amount: number): CLP {
  if (!Number.isFinite(amount)) throw new Error('CLP amount must be finite');
  return Object.freeze({ amount: Math.round(amount) });
}

/** Suma dos CLP. */
export function addClp(a: CLP, b: CLP): CLP {
  return clp(a.amount + b.amount);
}

/** Resta dos CLP. */
export function subClp(a: CLP, b: CLP): CLP {
  return clp(a.amount - b.amount);
}

/** Multiplica un CLP por un factor. Redondea al peso. */
export function mulClp(a: CLP, factor: number): CLP {
  if (!Number.isFinite(factor)) throw new Error('factor must be finite');
  return clp(a.amount * factor);
}

/**
 * Formato legible chileno: "$1.234.567"
 * Usa la Intl API con locale es-CL y currency CLP (0 decimales).
 */
export function formatClp(amount: CLP, locale = 'es-CL'): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'CLP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount.amount);
}
